module.exports = __webpack_public_path__ + "static/media/repeat-square.6bd67fdd.svg";